export * from './lib/UiLoyaltyLabelBase';
